import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select'
import {MatTabsModule} from '@angular/material/tabs';
@NgModule({
  imports: [
   MatButtonModule,
   MatCardModule,
     MatCheckboxModule,
   MatExpansionModule,
  // MatFormFieldModule,
   MatInputModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatTabsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
  ],
  exports: [
    MatButtonModule,
    MatCardModule,
     MatCheckboxModule,
    MatExpansionModule,
    MatInputModule,
   // MatFormFieldModule,
     MatProgressSpinnerModule,
     MatRadioModule,
     MatTabsModule,
     MatDatepickerModule,
     MatNativeDateModule,
     MatSelectModule,
  ],
  declarations: [
  ]
})
export class MaterialModule {}
